export function resolvePersonnelType(value) {
    return value === 'office' ? 'office' : 'driver';
}

export function isOfficePersonnel(user) {
    return resolvePersonnelType(user?.personnelType) === 'office';
}

/** Company driver filling forms. Admins and office staff are excluded. */
export function isFieldDriver(user) {
    if (!user) return false;
    if (user.role === 'admin' || user.role === 'company_admin') return false;
    return !isOfficePersonnel(user);
}

export function isOfficeTimeOffRequest(request) {
    if (!request) return false;
    if (request.personnelType === 'office') return true;
    if (request.personnelType === 'driver') return false;
    return Boolean(request.isPartialDay && !request.leavingYardAt);
}
